import type { JSX, ReactNode } from 'react';
import { Fragment, Children } from 'react';

import { cssClasses } from 'pkg/css/utils';

import MaterialSymbol from 'components/material-symbols';

import type { MaterialSymbolVariant } from 'components/material-symbols/symbols';

import * as css from './styles.css';

interface TitleProps {
	medium?: boolean;
	large?: boolean;
	thin?: boolean;
	centered?: boolean;
	icon?: MaterialSymbolVariant | MaterialSymbolVariant[];
	iconScale?: number;
	iconActualSize?: boolean;
	minHeight?: number;
}

interface SectionTitleComponentProps extends TitleProps {
	children: ReactNode;
	className?: string;
	wrapperClassName?: string;
	description?: string;
}

export default function SectionTitleComponent({
	children,
	medium,
	large,
	thin,
	centered,
	icon,
	iconScale = 1,
	iconActualSize,
	description,
	className,
	wrapperClassName,
	minHeight = 30,
}: SectionTitleComponentProps): JSX.Element {
	let title: ReactNode;
	let icons: MaterialSymbolVariant[] = [];

	const newChildren = Children.toArray(children);

	if (icon) {
		icons = Array.isArray(icon) ? icon : [icon];
		title = newChildren.shift();
	} else {
		title = children;
	}

	return (
		<div className={cssClasses(css.wrapper, wrapperClassName)}>
			<h2
				style={{ minHeight }}
				className={cssClasses(
					css.title,
					medium ? css.medium : '',
					large ? css.large : '',
					thin ? css.thin : '',
					centered ? css.centered : '',
					className
				)}>
				{icon ? (
					<Fragment>
						<span className={css.iconText}>
							{icons.map((iconVariant, index) => (
								<MaterialSymbol
									key={index}
									className={css.icon}
									variant={iconVariant}
									scale={iconScale}
									actualSize={iconActualSize}
								/>
							))}
							{title}
						</span>
						{newChildren}
					</Fragment>
				) : (
					children
				)}
			</h2>
			{description && <span className={css.description}>{description}</span>}
		</div>
	);
}
